// extracted by css-extract-rspack-plugin
export default {"isDraggedOver":"CopilotComposerInput-module__isDraggedOver__vBL5R"};